import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import 'react-toastify/dist/ReactToastify.css'
import { Layout } from '../components/Layout'
import store from '../components/Stores/SurveyStore'
import PrivateRoute from '../Routing/PrivateRoute'

//The SurveyElement component is used to render input questions (ie: textinput, numinput, calculated, textarea)
import SurveyPage from '../components/SurveyPage'
import SurveyTitleArea from '../components/SurveyTitleArea'
import SurveyContentContainer from '../components/SurveyContentContainer'

import PreviousYearDataPanel from '../components/PreviousYearDataPanel'
import SubsectionPanel from '../components/SubsectionPanel'

//Modals
import HelpModal from '../components/Modals/HelpModal'
import AddCommentModal from '../components/Modals/AddCommentModal'
import DeveloperWindow from '../components/DeveloperWindow'
import AddExplanationModal from '../components/Modals/AddExplanationModal'
import LogoutConfirmModal from '../components/Modals/LogoutConfirmModal'
import PrintModal from '../components/Modals/PrintModal'
import PabsLaundromatPage from '../components/Laundromat/PabsLaundromatPage'

//only used on unlock page for now
import { NavLink } from 'reactstrap'
import { Link, Switch } from 'react-router-dom'

import { unlockSurveyCtrl, LoadPABSSurvey } from '../control'

import { ToastContainer, Slide } from 'react-toastify'

import SurveyLoadingScreen from '../components/SurveyLoadingScreen'

// Tabs
import { PabsUkHomeTab } from './PabsUkSurvey.HomeTab'
import { PabsUkStartTab } from './PabsUkSurvey.StartTab'
import { PabsUkCostsTab } from './PabsUkSurvey.CostsTab'
import { PabsUkMembersTab } from './PabsUkSurvey.MembersTab'
import { PabsUkActivesTab } from './PabsUkSurvey.ActivesTab'
import { PabsUkDeferredsTab } from './PabsUkSurvey.DeferredsTab'
import { PabsUkPensionersTab } from './PabsUkSurvey.PensionersTab'
import { PabsUkAllMembersTab } from './PabsUkSurvey.AllMembersTab'
import { PabsUkDigitalTab } from './PabsUkSurvey.DigitalTab'
import { PabsUkCallsTab } from './PabsUkSurvey.CallsTab'
import { PabsUkVoCTab } from './PabsUkSurvey.VoCTab'
import { PabsUkSubmitTab } from './PabsUkSurvey.SubmitTab'

const Unlock = () => {
    const clickUnlock = () => {
        unlockSurveyCtrl()
    }
    return (
        <React.Fragment>
            <SurveyPage>
                <SurveyTitleArea labelText="What's Next?" subtext='' />
                <SurveyContentContainer>
                    <p>
                        Data quality is very important to us. Our analysts will review your
                        data and follow up with questions, if any. If you would like to edit
                        your survey, you must unlock it using the button below. You will
                        need to validate and resubmit your survey after making the edits.
                    </p>
                    <div className='center'>
                        <button type='button' disabled className='btn btn-unlock'>
                            Print Survey
                        </button>
                        <NavLink
                            tag={Link}
                            to={'./Submit'}
                            onClick={clickUnlock}
                            className='btn btn-unlock'
                        >
                            {' '}
                            Unlock Survey
                        </NavLink>
                        <NavLink
                            tag={Link}
                            to={'./PrintErrorSummary'}
                            className='btn btn-unlock'
                        >
                            {' '}
                            See Error Summary
                        </NavLink>
                    </div>
                </SurveyContentContainer>
            </SurveyPage>
        </React.Fragment>
    )
}

export const PabsUkSurvey = observer(() => {
    useEffect(() => {
        if (store.currentSurvey == null || store.currentSurvey[0] == null) {
            LoadPABSSurvey()
        }
    }, [])

    if (store.loadingSurvey) {
        return <SurveyLoadingScreen />
    }

    return (
        <Layout>
            <Switch>
                <PrivateRoute
                    exact
                    path='/pabsuk'
                    component={PabsUkHomeTab}
                    allowIfPageExists='Home'
                    allowClientAccess
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Home'
                    component={PabsUkHomeTab}
                    allowIfPageExists='Home'
                    allowClientAccess
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Start'
                    component={PabsUkStartTab}
                    allowIfPageExists={store.local.start}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Costs'
                    component={PabsUkCostsTab}
                    allowIfPageExists={store.local.costs}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Membership'
                    component={PabsUkMembersTab}
                    allowIfPageExists={store.local.membership}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Actives'
                    component={PabsUkActivesTab}
                    allowIfPageExists={store.local.actives}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Deferreds'
                    component={PabsUkDeferredsTab}
                    allowIfPageExists={store.local.deferreds}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Pensioners'
                    component={PabsUkPensionersTab}
                    allowIfPageExists={store.local.pensioners}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/AllMembers'
                    component={PabsUkAllMembersTab}
                    allowIfPageExists={store.local.allMember}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Digital'
                    component={PabsUkDigitalTab}
                    allowIfPageExists={store.local.digital}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Calls'
                    component={PabsUkCallsTab}
                    allowIfPageExists={store.local.calls}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/VoC'
                    component={PabsUkVoCTab}
                    allowIfPageExists={store.local.voc}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/laundromat'
                    component={PabsLaundromatPage}
                />
                <PrivateRoute
                    exact
                    path='/pabsuk/Submit'
                    component={PabsUkSubmitTab}
                    allowIfPageExists='Home'
                />
                <PrivateRoute path='*' component={PabsUkHomeTab} allowClientAccess />
            </Switch>

            <SubsectionPanel />
            <PreviousYearDataPanel />

            <HelpModal />
            <AddCommentModal />
            <AddExplanationModal />
            <DeveloperWindow />
            <ToastContainer transition={Slide} />
            <LogoutConfirmModal />
            <PrintModal />
        </Layout>
    )
})
